// @ts-ignore
import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { IGraphResponse } from 'entities/cdn'

import { fetchPriceChart, ITimeFrameValue } from 'services/cdn'
// import { Context } from 'data/context'
import { AreaChartWrapper } from 'components/Charts/Wrappers'
import { Button, CurrencyIcon, Loader } from 'components/Core'
import { mapProductPrice } from 'components/Charts/Victory/AreaChart/mapper'
import { useProducts } from 'hooks/useProducts'
import { useCurrencies } from 'hooks/useCurrencies'
import { timeIntervals } from 'constants/index'
import { Card } from 'components/Core/Card/Card'

export const AllCharts = () => {
    const productLimit = 31;
    const products = useProducts();
    const currencies = useCurrencies()
    const [searchParams] = useSearchParams();
    const navigate = useNavigate()
    // const { currencies } = useContext(Context);
    // const argTypes = useArgTypes()

    // #region STATE
    const [charts, setCharts] = useState<{
        [key in string]: {
            color: string;
            data: IGraphResponse;
            loading: boolean;
        }
    }>(products?.map((p: any) => ({
        loading: true,
    })))

    const timeFromUrl = searchParams?.get('timeInterval') as string;
    const [timeInterval,] = useState<{
        value: ITimeFrameValue,
        label: string
    }>({
        value: timeFromUrl as ITimeFrameValue || '365',
        label: timeIntervals.find((t: any) => t.value === timeFromUrl)?.label || timeFromUrl,
    })
    //#endregion

    // #region HANDLERS
    // const handleTimeInterval = (value: ITimeFrameValue) => {
    //     setInterval(value)
    // }
    // #endregion

    // #region LIFECYCLE
    useEffect(() => {
        console.log('')
        if (products?.length) {
            // TODO: set price chart
            products?.slice(0, productLimit)?.forEach((p: any) => {
                setCharts((prevState) => ({
                    [p?.code]: {
                        // @ts-ignore
                        ...prevState[p?.code],
                        loading: true
                    }
                }))

                fetchPriceChart({
                    productCode: p.code,
                    productType: p.category,
                    //@ts-ignore
                    timeFrame: timeInterval.value,
                    baseCurrency: 'ZAR'
                })
                    .then((result: any) => {
                        // console.log('storybook result', result);

                        setCharts((prevState) => ({
                            ...prevState,
                            [p?.code]: {
                                color: currencies?.[p.code]?.colors?.primary,
                                data: result,
                                loading: false
                            }
                        }))

                    }).catch(error => {
                        console.log(error)
                    })
            })
        }
    }, [products, timeInterval, currencies])

    useEffect(() => {
        if (charts) {
            console.log('mappedChartData', mapProductPrice(charts?.[Object.keys(charts)[0]]?.data?.Values))
        } else {
            console.info('charts is empty')
        }
    }, [charts, products])
    // #endregion

    return <>
        {/* <div style={{ margin: 'auto', minWidth: '8.5rem', maxWidth: '10rem' }}>
            <Dropdown
                value={timeInterval}
                onChange={handleTimeInterval}
                options={timeIntervals}
            />
        </div> */}

        {/* TODO: use type created by John */}
        {(products || []).slice(0, productLimit)?.map?.((p: any) => (
            <div style={{ width: '100%', minHeight: '2rem', paddingBottom: '1rem', marginBottom: '2rem', backgroundColor: `${p.colors?.primary}01` }}>
                {
                    charts[p.code]?.loading ? (
                        <Loader />
                    ) : (
                        <>
                                <Card id={`price-chart-${p.code}`} style={{ paddingTop: '1rem', paddingBottom: '1rem', margin: '1rem', width: 'calc(100% - 2rem)' }}>
                                <Button
                                    primary
                                    backgroundColor={`${p.colors?.primary}66` || '#00adee'}
                                    onClick={() => navigate(`/charts/price?productCode=${p.code.toUpperCase()}&timeInterval=${timeInterval?.value}&counterAsset=ZAR`)}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '-0.5rem' }}>
                                        <CurrencyIcon code={p?.code} />
                                        <div style={{ height: '1.5rem', lineHeight: '1.5rem', marginLeft: '1rem' }}>{p.code}</div>
                                    </div>
                                </Button>
                                <AreaChartWrapper
                                    data={mapProductPrice(charts?.[p.code]?.data?.Values || [])}
                                    // mappingFn={mapProductPrice}
                                    // color={p.colors.primary}
                                    color={p.colors?.primary || '#00adee'}
                                />
                            </Card>
                            <div style={{
                                // backgroundColor: '#88888888',
                                marginTop: '0.5rem',
                                marginBottom: '0.5rem',
                                width: '100%',
                                height: '1px'
                            }}></div>

                        </>
                    )
                }
            </div>
        ))}
    </>
}